export const parsePermissionArray = (value: unknown): string[] => {
    const parsed =
        typeof value === "string"
            ? JSON.parse(value.trim() || "[]")
            : value;

    if (!Array.isArray(parsed)) {
        return [];
    }

    return Array.from(new Set(parsed.map((item) => String(item).trim()).filter(Boolean)));
};

export const safeParsePermissionArray = (value: unknown): string[] => {
    try {
        return parsePermissionArray(value);
    } catch {
        return [];
    }
};

export const serializePermissionArray = (value: string[]) => JSON.stringify(Array.from(new Set(value)).sort(), null, 2);
